/**
 * @flow
 */

import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import RootApp from './app/App'
import store from './app/store'
import './index.css'

render(
  <Router>
    <Provider store={store}>
      <RootApp />
    </Provider>
  </Router>,
  document.querySelector('#app')
)
